import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import "../util/string";

@Injectable({
    providedIn: 'root'
})
export class MockProviderService {
    constructor(private httpClient: HttpClient) {}

    public getResponse<T>(caller: string): Promise<T> {
        return this.httpClient.get<T>("mocks/{0}.mock.json".format(caller)).toPromise();
    }
}